import {
  Badge,
  Button,
  Card,
  CardBody,
  CardFooter,
  CardTitle,
  FormGroup,
  Input,
  Table
} from "reactstrap";
import React, {
  useEffect,
  useState,
  useMemo,
  useCallback
} from 'react'
import NoRecord from "../../../CommonData/norecord/norecord";
import moment from 'moment';
import { connect } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { getPager } from "../../../helper/common";
import VWPagination from "../../../components/vwPagination/vwPagination";
import {
  MASTER_DEVICE_EXPORT_HEADERS,
  STATUS_LIST
} from "../../../store/device/actionTypes";
import {
  closeCreateMasterDeviceModal,
  exportMasterData,
  exportMasterDataByCustomer,
  getMasterDevicesList,
  getMasterDevicesListByCustomer,
  openCreateMasterDeviceModal
} from "../../../store/device/actions";
import { RETAILER } from "../../../store/users/role.constants";
import { excelPrint } from "../../../helper/export";
import Message from "../../../CommonData/Data/Message";
import VWLoading from "../../../components/vwLoading/vwLoading";
import debounce from "lodash/debounce";
import "../../FixedColumn.css";
import UITooltip from "../../../CommonData/Data/UITooltip";

const style = {
  table: {
    width: '100%',
    display: 'table',
    borderSpacing: 0,
    borderCollapse: 'separate',
  },
  th: {
    top: 0,
    left: 0,
    zIndex: 2,
    position: 'sticky',
    backgroundColor: '#fff',
  },
};

const DeviceList = (props) => {
  const { masterDeviceList, isGetMasterDevicesPending, currentProfile, errorMessage } = props;
  const [pageSize, setPageSize] = useState(10);
  const [pager, setPager] = useState({ currentPage: 1, });
  const [filter, setFilter] = useState();
  // const [filterDisplay, setFilterDisplay] = useState();


  const location = useLocation();
  const queryString = location.pathname;
  const urlParams = queryString && queryString.split("/");
  const reqParams = (urlParams && urlParams.length) > 0 ? urlParams[2] : null;

  ///-----------------------FILTER------------------------------------------------
  const buildQueryUID = () => {
    const { uid } = filter || {};
    let searchUid = '';
    if (uid) {
      searchUid += `${uid}`;
    }
    return searchUid
  }

  const buildQueryFriendlyName = () => {
    const { friendlyName } = filter || {};
    let searchfriendlyName = '';
    if (friendlyName) {
      searchfriendlyName += `${friendlyName}`;
    }
    return searchfriendlyName
  }

  const buildQueryIsActive = () => {
    const { isActive } = filter || {};
    let searchIsActive = '';
    if ((isActive !== null) && (isActive !== undefined)) {
      searchIsActive += `${isActive}`;
    }
    return searchIsActive
  }
  const buildQueryAssignedDeviceCount = () => {
    const { assignedDeviceCount } = filter || {};
    let searchAssignedDeviceCount = '';
    if (assignedDeviceCount) {
      searchAssignedDeviceCount += `${assignedDeviceCount}`;
    }
    return searchAssignedDeviceCount
  }
  const buildQueryAssignedByUserEmail = () => {
    const { assignedByUserEmail } = filter || {};
    let searchAssignedByUserEmail = '';
    if (assignedByUserEmail) {
      searchAssignedByUserEmail += `${assignedByUserEmail.replace(/\+/g, "%2B")}`;
    }
    return searchAssignedByUserEmail
  }
  const buildQueryEndCustomerName = () => {
    const { endCustomerName } = filter || {};
    let searchEndCustomerName = '';
    if (endCustomerName) {
      searchEndCustomerName += `${endCustomerName}`;
    }
    return searchEndCustomerName
  }
  const buildQueryEndCustomerEmail = () => {
    const { endCustomerEmail } = filter || {};
    let searchEndCustomerEmail = '';
    if (endCustomerEmail) {
      searchEndCustomerEmail += `${endCustomerEmail}`;
    }
    return searchEndCustomerEmail
  }
  const buildQueryEndCustomerZone = () => {
    const { endCustomerZone } = filter || {};
    let searchEndCustomerZone = '';
    if (endCustomerZone) {
      searchEndCustomerZone += `${endCustomerZone}`;
    }
    return searchEndCustomerZone
  }
  const buildQueryEndCustomerZip = () => {
    const { endCustomerZip } = filter || {};
    let searchEndCustomerZip = '';
    if (endCustomerZip) {
      searchEndCustomerZip += `${endCustomerZip}`;
    }
    return searchEndCustomerZip
  }
  const buildQuerySubscriptionValidity = () => {
    const { subscriptionValidity } = filter || {};
    let searchSubscriptionValidity = '';
    if (subscriptionValidity) {
      searchSubscriptionValidity += `${subscriptionValidity}`;
    }
    return searchSubscriptionValidity
  }
  const buildQueryCreatedDateTime = () => {
    const { createdDateTime } = filter || {};
    let searchCreatedDateTime = '';
    if (createdDateTime) {
      searchCreatedDateTime += `${createdDateTime}`;
    }
    return searchCreatedDateTime
  }

  const setPage = (page = 1) => {
    if (reqParams === 'master-devices-customers') {
      props.getMasterDevicesListByCustomer(page, pageSize, buildQueryUID(), buildQueryFriendlyName(), buildQueryIsActive(), buildQueryAssignedDeviceCount(),
        buildQueryAssignedByUserEmail(), buildQueryEndCustomerName(), buildQueryEndCustomerEmail(), buildQueryEndCustomerZone(),
        buildQueryEndCustomerZip(), buildQuerySubscriptionValidity(), buildQueryCreatedDateTime(), sortOrder, sortDirection);
    }
    else {
      props.getMasterDevicesList(page, pageSize, buildQueryUID(), buildQueryFriendlyName(), buildQueryIsActive(), buildQueryAssignedDeviceCount(),
        buildQueryAssignedByUserEmail(), buildQueryEndCustomerName(), buildQueryEndCustomerEmail(), buildQueryEndCustomerZone(),
        buildQueryEndCustomerZip(), buildQuerySubscriptionValidity(), buildQueryCreatedDateTime(), sortOrder, sortDirection);
    }
    setPager(prevPager => {
      const totalPages = Math.ceil(props.totalRecordsCount / pageSize);
      const visiblePages = 5;
      const pageOffset = Math.max(0, Math.floor((page - 1) / visiblePages) * visiblePages);
      const newPages = [];
      for (let i = pageOffset + 1; i <= Math.min(totalPages, pageOffset + visiblePages); i++) {
        newPages.push(i);
      }
      return {
        ...prevPager,
        currentPage: page,
        totalPages,
        pages: newPages,
      };
    });
  };

  useEffect(() => {
    const currentUpdatePager = getPager(props.totalRecordsCount, 1, pageSize);
    setPager(currentUpdatePager);
  }, [props.totalRecordsCount, pageSize]);

  // useEffect(() => {
  //   const currentPageNo = pager && pager.currentPage;
  //   setPage(currentPageNo);
  // }, []);

  useEffect(() => {
    setPage();
  }, [pageSize])


  const sendBackendRequest = useCallback((name, value) => {
    setFilter((prevState) => ({
      ...prevState,
      [name]: value
    }));
  }, []);

  const debouncedSendRequest = useMemo(() => {
    return debounce(sendBackendRequest, 1000);
  }, [sendBackendRequest]);

  const searchInputValidation = (event) => {
    const input = event.target;
    const { value, name } = input;
    debouncedSendRequest(name, value)
  }

  const handleSearchClick = () => {
    setPage();
  };

  const handleKeypress = (e) => {
    if (e.key === 'Enter') {
      handleSearchClick();
    }
  };

  useEffect(() => {
    if (filter) {
      handleSearchClick();
    }
  }, [filter])

  //-----------------------SORTING------------------------------------------------

  const [sortDirection, setSortDirection] = useState('asc');
  const [sortOrder, setSortOrder] = useState(null);

  const handleSort = (column) => {
    if (sortOrder === column) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortOrder(column);
      setSortDirection('asc');
    }
  };
  useEffect(() => {
    if (sortOrder && sortDirection) {
      setPage();
    }
  }, [sortOrder, sortDirection])
  //-----------------------EXPORT--------------------------------------------------

  const handleExportMasterDevices = () => {
    const { exportMasterData, exportMasterDataByCustomer } = props;
    if (reqParams === 'master-devices-customers') {
      exportMasterDataByCustomer().then((responseData) => {
        if (responseData) {
          var headers = MASTER_DEVICE_EXPORT_HEADERS;
          const headerSizes = [20, 20, 20, 20, 50, 50, 50, 50, 20, 20, 30, 30]
          var exportedData = [];
          responseData.forEach((element) => {
            exportedData.push({
              deviceKey: element.uid || "NA",
              friendlyName: element.friendlyName || "NA",
              isActive: element.isActive ? "Active" : "Inactive",
              assignedDeviceCount: element.assignedDeviceCount || 0,
              assignedByUserName: element.assignedByUserName || 0,
              assignedByUserEmail: element.assignedByUserEmail || 0,
              endCustomerName: element.endCustomerName || "NA",
              endCustomerEmail: element.endCustomerEmail || "NA",
              endCustomerZone: element.endCustomerZone || "NA",
              endCustomerZip: element.endCustomerZip || "NA",
              subscriptionValidity: element.subscriptionValidity ? moment(element.subscriptionValidity).format("DD/MM/YYYY") : "NA",
              createdDateTime: element.createdDateTime ? moment(element.createdDateTime).format("DD/MM/YYYY") : "NA",
            });
          });

          excelPrint(exportedData, "Master-Device-List", headers, headerSizes);
        }
      });
    }
    else {
      exportMasterData().then((responseData) => {
        if (responseData) {
          var headers = MASTER_DEVICE_EXPORT_HEADERS;
          const headerSizes = [20, 20, 20, 20, 50, 50, 50, 50, 20, 20, 30, 30]
          var exportedData = [];
          responseData.forEach((element) => {
            exportedData.push({
              deviceKey: element.uid || "NA",
              friendlyName: element.friendlyName || "NA",
              isActive: element.isActive ? "Active" : "Inactive",
              assignedDeviceCount: element.assignedDeviceCount || 0,
              assignedByUserName: element.assignedByUserName || "NA",
              assignedByUserEmail: element.assignedByUserEmail || "NA",
              endCustomerName: element.endCustomerName || "NA",
              endCustomerEmail: element.endCustomerEmail || "NA",
              endCustomerZone: element.endCustomerZone || "NA",
              endCustomerZip: element.endCustomerZip || "NA",
              subscriptionValidity: element.subscriptionValidity ? moment(element.subscriptionValidity).format("DD/MM/YYYY") : "NA",
              createdDateTime: element.createdDateTime ? moment(element.createdDateTime).format("DD/MM/YYYY") : "NA",
            });
          });

          excelPrint(exportedData, "Master-Device-List", headers, headerSizes);
        }
      });
    }
  };

  const isRetailer = currentProfile.roles && currentProfile.roles.length > 0 && currentProfile.roles[0].roleKey === RETAILER;

  return (
    // <React.Fragment className='bg-danger'>
    <div className="page-content">
      <Card>
        <CardTitle className="mb-0  p-2 d-flex justify-content-between align-items-center fs-5 fw-bold">
          {reqParams === 'master-devices-customers' ? 'MASTER DEVICES CREATED BY CUSTOMERS' : 'MASTER DEVICES'}
          <div className="content-heading">
            <div className="ml-auto">
              {(isRetailer && (reqParams === 'master-devices')) && (
                <Link
                  type="button"
                  className="mr-1 btn btn-primary btn-sm"
                  to="/devicelist/master-devices/add"
                >
                  <em className="fas fa-plus me-2"></em>   Create
                </Link>)}&nbsp;
              <Button
                color='primary'
                size='sm'
                onClick={handleExportMasterDevices}
              >
                <em className="fas fa-download me-2" />  Export
              </Button>
            </div>
          </div>
        </CardTitle>
      </Card>
      <Card>
        <CardBody>
          {errorMessage && (
            <Message
              type="danger"
              defaultMessage={errorMessage}
              baseClassName="alert"
            />
          )}
          <div style={{ maxHeight: "500px", overflowX: "auto" }}>
            <Table className="table table-hover table-striped table-nowrap w-100" size='sm' style={style.table}>
              <thead className='overflow-hidden sticky-top' style={{ backgroundColor: "white", overflow: "hidden", zIndex: "10" }}>
                <tr>
                  <th style={{ cursor: "pointer" }} onClick={() => handleSort('uid')}>
                    MASTER DEVICE UID&nbsp;
                    {sortOrder === 'uid' && (
                      <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                    )}
                  </th>
                  <th style={{ cursor: "pointer" }} onClick={() => handleSort('friendlyName')}>
                    FRIENDLY NAME&nbsp;
                    {sortOrder === 'friendlyName' && (
                      <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                    )}
                  </th>
                  <th onClick={() => handleSort('isActive')} style={{ minWidth: "120px", cursor: "pointer" }}>
                    STATUS&nbsp;
                    {sortOrder === 'isActive' && (
                      <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                    )}
                  </th>
                  <th onClick={() => handleSort('assignedDeviceCount')} style={{ width: "100px", cursor: "pointer" }}>
                    DEVICES&nbsp;
                    {sortOrder === 'assignedDeviceCount' && (
                      <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                    )}
                  </th>
                  <th style={{ cursor: "pointer" }} onClick={() => handleSort('assignedByUserName')}>
                    ASSIGNED BY USER
                    {sortOrder === 'assignedByUserName' && (
                      <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                    )}
                  </th>
                  <th style={{ cursor: "pointer" }} onClick={() => handleSort('endCustomerName')}>
                    CUSTOMER NAME&nbsp;
                    {sortOrder === 'endCustomerName' && (
                      <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                    )}
                  </th>
                  {/* <th onClick={() => handleSort('endCustomerEmail')}>
                  CUSTOMER EMAIL&nbsp;
                  {sortOrder === 'endCustomerEmail' && (
                    <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                  )}
                </th> */}
                  <th style={{ cursor: "pointer" }} onClick={() => handleSort('endCustomerZone')}>
                    CUSTOMER ZONE&nbsp;
                    {sortOrder === 'endCustomerZone' && (
                      <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                    )}
                  </th>
                  <th style={{ cursor: "pointer" }} onClick={() => handleSort('endCustomerZip')}>
                    CUSTOMER ZIP&nbsp;
                    {sortOrder === 'endCustomerZip' && (
                      <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                    )}
                  </th>
                  <th style={{ cursor: "pointer" }} onClick={() => handleSort('subscriptionValidity')}>
                    VALIDITY&nbsp;
                    {sortOrder === 'subscriptionValidity' && (
                      <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                    )}
                  </th>
                  <th style={{ cursor: "pointer" }} onClick={() => handleSort('createdDateTime')}>
                    CREATED ON&nbsp;
                    {sortOrder === 'createdDateTime' && (
                      <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                    )}
                  </th>
                  <th className="text-center sticky-column" style={{ backgroundColor: "white", overflow: "hidden", zIndex: '20' }}>
                    VIEW
                  </th>
                </tr>
                <tr>
                  <th>
                    <FormGroup>
                      <Input
                        type="text"
                        size='sm'
                        className="form-control"
                        placeholder="Search"
                        name="uid"
                        onChange={searchInputValidation}
                        onKeyPress={handleKeypress}
                      />
                    </FormGroup>
                  </th>
                  <th>
                    <FormGroup>
                      <Input
                        type="text"
                        size='sm'
                        className="form-control"
                        placeholder="Search"
                        name="friendlyName"
                        onChange={searchInputValidation}
                        onKeyPress={handleKeypress}
                      />
                    </FormGroup>
                  </th>
                  <th className="text-center">
                    <FormGroup>
                      <Input
                        type='select'
                        className="vm-react-select"
                        size='sm'
                        name='isActive'
                        placeholder="Select"
                        onChange={searchInputValidation}
                      >
                        <option value="" >Select</option>
                        {STATUS_LIST && STATUS_LIST.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>
                  </th>
                  <th>
                    <FormGroup>
                      <Input
                        type='number'
                        size='sm'
                        className="form-control"
                        placeholder="Search"
                        name="assignedDeviceCount"
                        onChange={searchInputValidation}
                        onKeyPress={handleKeypress}
                      />
                    </FormGroup>
                  </th>
                  <th>
                    <FormGroup>
                      <Input
                        className="form-control"
                        size='sm'
                        placeholder="Search"
                        name="assignedByUserEmail"
                        onChange={searchInputValidation}
                        onKeyPress={handleKeypress}
                      />
                    </FormGroup>
                  </th>
                  {/* <th>
                  <FormGroup>
                    <Input
                      type="text"
                      size='sm'
                      className="form-control"
                      placeholder="Search"
                      name="endCustomerName"
                      onChange={searchInputValidation}
                      onKeyPress={handleKeypress}
                    />
                  </FormGroup>
                </th> */}
                  <th>
                    <FormGroup>
                      <Input
                        type="text"
                        size='sm'
                        className="form-control"
                        placeholder="Search"
                        name="endCustomerEmail"
                        onChange={searchInputValidation}
                        onKeyPress={handleKeypress}
                      />
                    </FormGroup>
                  </th>
                  <th>
                    <FormGroup>
                      <Input
                        type="text"
                        className="form-control"
                        placeholder="Search"
                        size='sm'
                        name="endCustomerZone"
                        onChange={searchInputValidation}
                        onKeyPress={handleKeypress}
                      />
                    </FormGroup>
                  </th>
                  <th>
                    <FormGroup>
                      <Input
                        type="text"
                        className="form-control"
                        size='sm'
                        placeholder="Search"
                        name="endCustomerZip"
                        onChange={searchInputValidation}
                        onKeyPress={handleKeypress}
                      />
                    </FormGroup>
                  </th>
                  <th>
                    <FormGroup>
                      <Input
                        type="date"
                        className="form-control"
                        size='sm'
                        placeholder="Search"
                        name="subscriptionValidity"
                        onChange={searchInputValidation}
                        onKeyPress={handleKeypress}
                      />
                    </FormGroup>
                  </th>
                  <th>
                    <FormGroup>
                      <Input
                        type="date"
                        className="form-control"
                        size='sm'
                        placeholder="Search"
                        name="createdDateTime"
                        onChange={searchInputValidation}
                        onKeyPress={handleKeypress}
                      />
                    </FormGroup>
                  </th>
                  <th className="sticky-column" style={{ backgroundColor: "white", overflow: "hidden", zIndex: "20" }}></th>
                </tr>
              </thead>
              <tbody>
                {(masterDeviceList && masterDeviceList.length > 0) && !isGetMasterDevicesPending ?
                  masterDeviceList.map((data, index) => (
                    <tr key={index}>
                      <td align="center">
                        <div className="d-flex gap-1">
                          {data.uid || "NA"}
                          <div>
                            {!data.warningMessage.every(item => item === null) &&
                              <UITooltip id={`warning-${index}`} content={data.warningMessage?.map((i) => { return i })}>
                                <i class="fas fa-exclamation-triangle text-danger" style={{ cursor: "pointer" }} />
                              </UITooltip>
                            }
                          </div>
                        </div>
                      </td>
                      <td>{data.friendlyName || "NA"}</td>
                      <td>
                        {data.isActive ? (
                          <Badge color="success">Active</Badge>
                        ) : (
                          <Badge color="danger">Inactive</Badge>
                        )}
                      </td>
                      <td className="text-center">{data.assignedDeviceCount || "NA"}</td>
                      <td>
                        {data.assignedByUserName || "NA"}<br />
                        <small> {data.assignedByUserEmail || "NA"}</small>
                      </td>
                      <td>
                        {data.endCustomerName}<br />
                        <small>{data.endCustomerEmail}</small>
                      </td>
                      <td>{data.endCustomerZone || "NA"}</td>
                      <td>{data.endCustomerZip || "NA"}</td>
                      <td>{data.subscriptionValidity ? moment(data.subscriptionValidity).format("DD MMM YYYY") : "NA"}</td>
                      <td>{data.createdDateTime ? moment(data.createdDateTime).format("DD MMM YYYY") : "NA"}</td>
                      <td className="text-center sticky-column bg-white">
                        <Link
                          type="button"
                          className="btn btn-sm btn-light"
                          to={reqParams === 'master-devices-customers' ?
                            `/devicelist/master-devices-customers/details/${data.id}` : `/devicelist/master-devices/details/${data.id}`}
                        >
                          <em className="far fa-share-square"></em>
                        </Link>
                      </td>
                    </tr>
                  )) : isGetMasterDevicesPending ? (
                    <tr>
                      <td colSpan={12} align="center" className="p-4">
                        <VWLoading />
                      </td>
                    </tr>
                  ) : (
                    <tr>
                      <td colSpan={12}>
                        <NoRecord />
                      </td>
                    </tr>
                  )}
              </tbody>
            </Table>
          </div>
        </CardBody>
        <CardFooter>
          {masterDeviceList.length > 0 ? (
            <VWPagination
              pager={pager}
              setPage={setPage}
              totalRecords={props.totalRecordsCount}
              pageSize={pageSize}
              setPageSize={setPageSize}
            />
          ) : null}
        </CardFooter>
      </Card>
    </div>
    // </React.Fragment >
  )
}

const mapStateToProps = (state) => ({
  masterDeviceList: state.device.masterDevices,
  errorMessage: state.device.masterDeviceListErrorMsg,
  isGetMasterDevicesPending: state.device.isGetMasterDevicesPending,
  isCreateMasterDeviceModalOpen: state.device.isCreateMasterDeviceModalOpen,
  currentProfile: state.login.currentProfile,
  totalRecordsCount: state.device.totalMasterDeviceRecordsCount,
});

const mapDispatchToProps = (dispatch) => ({
  openCreateMasterDeviceModal: () => dispatch(openCreateMasterDeviceModal()),
  closeCreateMasterDeviceModal: () => dispatch(closeCreateMasterDeviceModal()),
  getMasterDevicesList: (currentPage, pagesize, searchUid, searchfriendlyName, searchIsActive, searchAssignedDeviceCount, searchAssignedByUserEmail,
    searchEndCustomerName, searchEndCustomerEmail, searchEndCustomerZone, searchEndCustomerZip, searchSubscriptionValidity, searchCreatedDateTime,
    sortOrder, sortDirection) => dispatch(getMasterDevicesList(currentPage, pagesize, searchUid, searchfriendlyName, searchIsActive, searchAssignedDeviceCount,
      searchAssignedByUserEmail, searchEndCustomerName, searchEndCustomerEmail, searchEndCustomerZone, searchEndCustomerZip, searchSubscriptionValidity,
      searchCreatedDateTime, sortOrder, sortDirection)),
  getMasterDevicesListByCustomer: (currentPage, pagesize, searchUid, searchfriendlyName, searchIsActive, searchAssignedDeviceCount, searchAssignedByUserEmail,
    searchEndCustomerName, searchEndCustomerEmail, searchEndCustomerZone, searchEndCustomerZip, searchSubscriptionValidity, searchCreatedDateTime,
    sortOrder, sortDirection) => dispatch(getMasterDevicesListByCustomer(currentPage, pagesize, searchUid, searchfriendlyName, searchIsActive, searchAssignedDeviceCount,
      searchAssignedByUserEmail, searchEndCustomerName, searchEndCustomerEmail, searchEndCustomerZone, searchEndCustomerZip, searchSubscriptionValidity,
      searchCreatedDateTime, sortOrder, sortDirection)),
  exportMasterData: () => dispatch(exportMasterData()),
  exportMasterDataByCustomer: () => dispatch(exportMasterDataByCustomer()),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeviceList);